export function localized(obj, lang) {
  if (obj === null || obj === undefined) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.en || "";
}

export function localizedList(obj, lang) {
  if (!obj) return [];
  if (Array.isArray(obj)) return obj;
  return obj[lang] || obj.en || [];
}
